import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import WhatsAppLogsList from './WhatsAppLogsList';
import SMSLogsList from './SMSLogsList';
import EmailLogsList from './EmailLogsList';


const ActivityRegisterScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    // const {

    // } = InvoiceSettingsController()

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:10}}>
                <h2 className='title'>Activity Register</h2>
            </div>

            <div >
            <Tabs tabs={['WhatsApp Logs','Email Logs','SMS Logs',]}
            selectedIndex={selectedTab}
            onTabChange={handleTabChange}>
                    <WhatsAppLogsList />
                    <EmailLogsList />
                    <SMSLogsList />
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default ActivityRegisterScreen;